import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Paper, Tabs, Tab, Grid, Typography, Icon} from '@material-ui/core'
import {compose} from 'redux'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import Page from 'src/shared/Page/Page'
import autobind from 'autobind-decorator'
import * as moment from 'moment'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import {css} from 'src/conf/style'

import EnterpriseInfo from 'src/page/Consumer/Enterprise/cards/EnterpriseInfos'
import EnterpriseForm from 'src/page/Consumer/Enterprise/cards/EnterpriseForm'
import EnterpriseDocuments from 'src/page/Consumer/Enterprise/cards/EnterpriseDocuments'
import EnterpriseContractual from 'src/page/Consumer/Enterprise/cards/EnterpriseContractual'
import EnterprisePhysicalPerson from 'src/page/Consumer/Enterprise/cards/EnterprisePhysicalPerson'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'


const styles = (t: Theme) => createStyles({
    root: {
        position: 'relative',
        flexGrow: 1,
        padding: t.spacing.unit * 4,
        backgroundColor: t.palette.background.paper,
    },
    tabsRoot: {
        marginBottom: t.spacing.unit * 4,
        borderBottom: '1px solid #e8e8e8'
    },
    tabsIndicator: {
        backgroundColor: t.palette.primary.main
    },
    tabRoot: {
        textTransform: 'initial',
        minWidth: 72,
        fontWeight: t.typography.fontWeightRegular,
        marginRight: t.spacing.unit * 4,
        '&:hover': {
            color: t.palette.primary.main,
            opacity: 1,
        },
        '&$tabSelected': {
            color: t.palette.primary.main,
            fontWeight: t.typography.fontWeightMedium,
        },
        '&:focus': {
            color: t.palette.primary.main,
        },
    },
    tabSelected: {

    },
    ribbon: {
        ...css.flexFullCenter,
        height: '50px',
        background: '#21749a',  
        right: '-8px',
        position: 'absolute',
        color: t.palette.common.white,
        fontWeight: 'bold',
        '&:before': {
            content: "''",
            position: 'absolute',
            height: 0,
            width: 0,
            borderStyle: 'solid',
            borderWidth: '8px 0 0 8px',
            top: '-8px',
            right: 0,
        },
        '&:after': {
            content: "''",
            position: 'absolute',
            height: 0,
            width: 0,
            borderStyle: 'solid',
            borderWidth: '25px 20px 25px 0',
            right: '250px'
        },
        '&$isPro':{
            width: '220px',
        },
        '&$notPro':{
            width: '250px',
        },
        '&$isPro:before': {
            borderColor: 'transparent transparent transparent #2E7D32',
        },
        '&$isPro:after': {
            borderColor: `transparent #2E7D32 transparent transparent`,
            right: '220px'
        },
        '&$notPro:before': {
            borderColor: 'transparent transparent transparent #0277BD',
        },
        '&$notPro:after': {
            borderColor: `transparent #0277BD transparent transparent`,
        },
    },
    isPro: { background: '#2E7D32', },
    notPro: {  background: '#0277BD', },
    infoHeader: { ...css.flexAlCenter, paddingTop: '80px !important'},
    ribbonText: { marginLeft: '5px'},
    tabHeaderWithIcon: {
        ...css.flexAlCenter
    }
});


interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}

interface IStates {
    tabActive: number;
}

class Enterprise extends React.Component<IProps, IStates> {
    state = {
        tabActive: 0,
    };

  render(){
    const { t, classes, enterprise, connectedUser } = this.props;
    const { tabActive } = this.state;
    return(
       <Page width={1050}>
           
            <HelmetMeta title={enterprise.name}/>
            <Paper className={classes.root}>
                <div className={[classes.ribbon , enterprise.is_pro === true ? classes.isPro : classes.notPro].join(' ')}>
                    {enterprise.is_pro === true &&
                        <Icon>layers</Icon>
                    }
                    {enterprise.is_pro === false &&
                        <Icon>layers_clear</Icon>
                    }
                    <p className={classes.ribbonText}>{enterprise.is_pro === true ? "Professionnel MIF" : "Non professionnel MIF"}</p>
                </div>
                <Grid container>
                    <Grid item xs={12} className={classes.infoHeader}>
                        <Icon style={{marginRight: '10px'}}>business</Icon>
                        <Typography component="h5" variant="h5">{enterprise.name}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Tabs
                        value={tabActive}
                        onChange={this.handleChange}
                        classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                        scrollable scrollButtons="off"
                        >
                            <Tab
                                disableRipple
                                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                label={t.EnterpriseDetail_tab_information}
                            />
                            {enterprise.is_pro === false && connectedUser.read_only_access === false && 
                                <Tab
                                    disableRipple
                                    classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                    label={
                                        <>
                                            {this.isFormShouldBeUpdate() === true &&
                                                <div className={classes.tabHeaderWithIcon}>
                                                    {t.EnterpriseDetail_tab_question}
                                                    <Icon color="error" style={{marginLeft: '5px'}}>info</Icon>
                                                </div>
                                            }
                                            {this.isFormShouldBeUpdate() === false &&
                                                t.EnterpriseDetail_tab_question
                                            }
                                        </>
                                    }
                                />
                            }
                            <Tab
                                disableRipple
                                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                label="Pack contractuel"
                            />
                            <Tab
                                disableRipple
                                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                label={
                                    <>
                                        {enterprise.can_edit_contractual_data === true && 
                                            <div className={classes.tabHeaderWithIcon}>
                                                {t.EnterpriseDetail_tab_contractual}
                                                {enterprise.is_mandataire &&
                                                    <Icon color="error" style={{marginLeft: '5px'}}>info</Icon>
                                                }
                                            </div>
                                        }
                                        {enterprise.can_edit_contractual_data === false &&
                                            t.EnterpriseDetail_tab_contractual
                                        }
                                    </>
                                }
                            />
                            {enterprise.is_mandataire === true &&
                                <Tab
                                    disableRipple
                                    classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                    label={t.EnterpriseDetail_tab_physical_person}
                                />
                            }
                        </Tabs>

                        {this.tabContentRendering(tabActive)}
                    </Grid>
                </Grid>
            </Paper>
        </Page>
    )
  }

  @autobind
  private handleChange(event, value) {
    this.setState({ tabActive: value });
  };

  @autobind
  private isFormShouldBeUpdate(){
      const {enterprise} = this.props;
      if(enterprise !== undefined && enterprise.qp_last_updated_at !== undefined){
        const dateFormShouldBeUpdateStart = moment(enterprise.qp_last_updated_at).add(moment.duration(2, 'years').asDays(), 'd').subtract(90, 'd').format()
        const dateFormShouldBeUpdateEnd = moment(enterprise.qp_last_updated_at).add(moment.duration(2, 'years').asDays(), 'd').format()
        return moment().isBetween(dateFormShouldBeUpdateStart, dateFormShouldBeUpdateEnd) 
            || moment().isAfter(dateFormShouldBeUpdateEnd) 
            || moment().diff(moment(dateFormShouldBeUpdateEnd), 'days') === 0
      } else {
          return false;
      }
  }

  private tabContentRendering(tabActive){
    const { enterprise, connectedUser } = this.props;
      switch(tabActive){
        case 0: 
            return(
                <EnterpriseInfo />
            )
        case 1: 
            return(
                enterprise.is_pro === false && connectedUser.read_only_access === false ? <EnterpriseForm isFormShouldBeUpdate={this.isFormShouldBeUpdate()} /> : <EnterpriseDocuments />
            )
        case 2:
            return(
                enterprise.is_pro === false && connectedUser.read_only_access === false ? <EnterpriseDocuments /> : <EnterpriseContractual />
            )
        case 3:
            return (
                enterprise.is_pro === false && connectedUser.read_only_access === false ?  <EnterpriseContractual /> : <EnterprisePhysicalPerson />
            )
        case 4:
            return (
                <EnterprisePhysicalPerson />
            )
        default: 
            return '';
      }
  }
}

const state2props = (state: RootState) => ({
  enterprise: state.accountInfo.enterpriseSelected,
  connectedUser: state.accountInfo.connectedUser
});

const dispatch2props = dispatch => ({
});

export default compose(
  withI18n,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(Enterprise)



// WEBPACK FOOTER //
// ./src/page/Consumer/Enterprise/Enterprise.tsx